import axios from '../../lib/api';
import actionWrapper from '../../lib/actionWrapper';
import Config from '../../configs/config';
import { _arrayBufferToBase64 } from '../../lib/utils';

export default {
  namespace: 'util',

  state: {
    snackbarOpen: false,
    snackbarMessage: '',
    snackBarSeverity: 'info',
    dialog: {
      open: false,
      title: '',
      icon: '',
      maxWidth: 'sm',
      message: '',
      okText: '',
      okButtonType: 'outlined',
      cancelText: '',
      cancelButtonType: 'outlined',
      okAction: () => { },
    },
    fileDownload: '',
    lookups: {},
  },

  effects: (dispatch) => ({

    setDialog({
      open,
      title,
      icon,
      maxWidth,
      message,
      okText,
      cancelText,
      okButtonType,
      cancelButtonType,
      okAction,
      cancelAction,
    }) {
      this.dialog_reducer({
        open,
        title,
        icon,
        maxWidth,
        message,
        okText,
        cancelText,
        okButtonType,
        cancelButtonType,
        okAction,
        cancelAction,
      });
    },

    sendAlert({ snackbarMessage, snackbarOpen, snackBarSeverity }) {
      this.alert_reducer({
        snackbarMessage,
        snackbarOpen,
        snackBarSeverity,
      });
    },

    async errorHandler(error) {
      const { status, data, config } = error?.response || {};

      if (status === 400) {
        return dispatch.util.sendAlert({
          snackbarMessage: data?.message || 'اطلاعات ارسال شده صحیح نیست',
          snackbarOpen: true,
          snackBarSeverity: 'error',
        });
      }

      if (status === 401 && config?.url !== Config.authUrl) {
        return dispatch.util.sendAlert({
          snackbarMessage: data?.message,
          snackbarOpen: true,
          snackBarSeverity: 'error',
        });
      }

      if (status === 403) {
        return dispatch.util.sendAlert({
          snackbarMessage: '403 شما دسترسی انجام این عملیات را ندارید!',
          snackbarOpen: true,
          snackBarSeverity: 'error',
        });
      }

      if (config?.url === Config.authUrl) {
        dispatch.util.sendAlert({
          snackbarMessage: 'نام کاربری یا رمز  وارد شده صحیح نمی‌باشد',
          snackbarOpen: true,
          snackBarSeverity: 'warning',
        });
        return;
      }

      return dispatch.util.sendAlert({
        snackbarMessage: data?.message || 'در ارتباط با سرور مشکلی پیش آمده ! ',
        snackbarOpen: true,
        snackBarSeverity: 'error',
      });
    },

    async fetchLookups() {
      return actionWrapper(
        async () => {
          const res = await axios({
            method: 'get',
            url: '/lookup',
          });
          await this.fetchLookups_reducer(res?.data);
          return res;
        },
        dispatch.util.errorHandler,
      );
    },

    async fetchFileDownload(filename) {
      return actionWrapper(
        async () => {
          const res = await axios({
            method: 'get',
            url: `file/download/${filename}`,
            responseType: 'arraybuffer',
          });
          await this.fetchFileDownload_reducer(_arrayBufferToBase64(res.data));
          return res;
        },
        dispatch.util.errorHandler,
      );
    },

    clearFileDownload() {
      return this.fetchFileDownload_reducer('');
    },

  }),

  reducers: {

    dialog_reducer(state, payload) {
      return {
        ...state,
        dialog: { ...state.dialog, ...payload },
      };
    },

    alert_reducer(state, { snackbarMessage, snackbarOpen, snackBarSeverity }) {
      return {
        ...state,
        snackbarMessage,
        snackbarOpen,
        snackBarSeverity,
      };
    },
    fetchLookups_reducer(state, payload) {
      return {
        ...state,
        lookups: payload,
      };
    },
    fetchFileDownload_reducer(state, payload) {
      return {
        ...state,
        fileDownload: payload,
      };
    },

  },
};
